import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import DraggableResizableDialog  from '../ui/DraggableResizableDialog';
import duplicateGroupDialogModel from './DuplicateGroupDialogModel';
import { withStyles }            from '../utility/styles';


const styles = (_theme: Theme) => ({
});

interface IDuplicateGroupDialogProps {
}

type DuplicateGroupDialogProps = WithStyle<ReturnType<typeof styles>, IDuplicateGroupDialogProps>;

class DuplicateGroupDialog extends React.PureComponent<DuplicateGroupDialogProps> {
  constructor(props: DuplicateGroupDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    duplicateGroupDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={duplicateGroupDialogModel.form} onSubmit={duplicateGroupDialogModel.actionFn('save')}>
        <div className='content'>
          <duplicateGroupDialogModel.form.field.name.Editor className='span1' />
        </div>
        <div className='content'>
          <duplicateGroupDialogModel.form.field.area.Editor className='span1' />
        </div>
        <div className='content'>
          <duplicateGroupDialogModel.form.field.startDate.Editor className='span1' />
          <duplicateGroupDialogModel.form.field.endDate.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: duplicateGroupDialogModel}}  DraggableResizableBoxProps={{minWidth: '268px', minHeight: '357px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IDuplicateGroupDialogProps>(styles, DuplicateGroupDialog);
